module.exports = __webpack_public_path__ + "img/external_link_symbol_blue.6d152c92.svg";